import { combineReducers } from '@reduxjs/toolkit';

import { debugMenuReducer } from './debug-menu/slice';
import { modalTypeReducer } from './modal-type/slice';
import { participantListReducer } from './participant-list/slice';

export const dtmfReducer = combineReducers({
    modal: modalTypeReducer,
    participantList: participantListReducer,
    debugMenu: debugMenuReducer,
});
